var module = {
  exports: {}
};
var exports = module.exports;
var LANGUAGES = {
  sg: {
    transify: 'en/',
    key: 'en'
  },
  my: {
    transify: 'en-my/',
    key: 'en-my'
  },
  ph: {
    transify: 'en-ph/',
    key: 'en-ph'
  },
  id: {
    transify: 'id/',
    key: 'id'
  },
  tw: {
    transify: 'zh-Hant/',
    key: 'zh-Hant'
  },
  vn: {
    transify: 'vi/',
    key: 'vi'
  },
  th: {
    transify: 'th/',
    key: 'th'
  },
  br: {
    transify: 'pt-BR/',
    key: 'pt-BR'
  },
  mx: {
    transify: 'es-MX/',
    key: 'es-MX'
  },
  'ms-my': {
    transify: 'ms-my/',
    key: 'ms-my'
  },
  'zh-my': {
    transify: 'zh-Hans/',
    key: 'zh-Hans'
  },
  // zh-cn没有所有的翻译文案，cn站点也使用zh-Hans
  cn: {
    transify: 'zh-Hans/',
    key: 'zh-Hans'
  },
  co: {
    transify: 'es-CO/',
    key: 'es-CO'
  },
  cl: {
    transify: 'es-CL/',
    key: 'es-CL'
  },
  es: {
    transify: 'es-ES/',
    key: 'es-ES'
  },
  fr: {
    transify: 'fr/',
    key: 'fr'
  },
  in: {
    transify: 'en-in/',
    key: 'en-in'
  },
  'en-id': {
    transify: 'en-id/',
    key: 'en-id'
  },
  'en-th': {
    transify: 'en-th/',
    key: 'en-th'
  },
  ar: {
    transify: 'es-ar/',
    key: 'es-ar'
  },
  pl: {
    transify: 'pl/',
    key: 'pl'
  }
};
module.exports.LANGUAGES = LANGUAGES;
export default module.exports;